import React, { useEffect, useState, useCallback } from "react";

import { DataLists } from "../../dataLists/DataLists";
import { dataListsType } from "../../components/featured-posts";
import { Link } from "react-router-dom";
import debounce from "lodash/debounce";

interface GoogleSearchResult {
  title: string;
  link: string;
  snippet: string;
  pagemap?: {
    cse_thumbnail?: Array<{
      src: string;
    }>;
  };
}

const SearchBar: React.FC = () => {
  const [searchValue, setSearchValue] = useState("");
  const [isShowSearchResults, setIsShowSearchResults] = useState(false);
  const [searchResults, setSearchResults] = useState<dataListsType[]>([]);
  const [popularRecommendations, setPopularRecommendations] = useState<
    dataListsType[]
  >([]);
  const [googleResults, setGoogleResults] = useState<GoogleSearchResult[]>([]);

  const getPopularRecommendations = () => {
    const allData = [...DataLists];
    const randomData = allData.sort(() => 0.5 - Math.random());
    setPopularRecommendations(randomData.slice(0, 12));
  };
  useEffect(() => {
    getPopularRecommendations();
  }, []);

  const performSearch = useCallback(async (inputValue: string) => {
    if (inputValue.trim() === "") {
      setIsShowSearchResults(false);
      setSearchResults([]);
      setGoogleResults([]);
    } else {
      setIsShowSearchResults(true);
      // 篩選本地搜索結果
      const filteredResults = DataLists.filter(
        (item) =>
          item.category.toLowerCase().includes(inputValue.toLowerCase()) ||
          item.tags.some((tag) =>
            tag.toLowerCase().includes(inputValue.toLowerCase())
          ) ||
          item.nation.toLowerCase().includes(inputValue.toLowerCase())
      );
      setSearchResults(filteredResults);

      // 發送Google搜尋請求
      try {
        const response = await fetch(
          `https://h5-backend-java-750219299255.asia-northeast1.run.app/search/googleSearch?query=${inputValue}`
        );
        const responseData = await response.json();
        console.log("Backend API response:", responseData);

        if (responseData.code === 400) {
          console.log("Search results exceed limit");
          setGoogleResults([]);
        } else if (
          responseData.code === 200 &&
          Array.isArray(responseData.data)
        ) {
          setGoogleResults(responseData.data);
          console.log("Google search results:", responseData.data);
        } else {
          console.log("No search results found or invalid response format");
          setGoogleResults([]);
        }
      } catch (error) {
        console.error("Error fetching Google search results:", error);
        setGoogleResults([]);
      }
    }
  }, []);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedSearch = useCallback(
    debounce((value: string) => performSearch(value), 1000),

    [performSearch]
  );

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;
    setSearchValue(inputValue);
    debouncedSearch(inputValue);
    console.log("Search value:", inputValue);
  };

  return (
    <>
      <div className="w-full flex flex-col justify-center items-center px-8">
        <div className="w-full h-[90px] max-w-[1116px] flex items-center justify-between text-3xl font-bold">
          <img
            src="icon/back.png"
            alt="back"
            onClick={() => window.history.back()}
            className="w-6 h-6 mr-3 flex-shrink-0 cursor-pointer"
          />
          <div
            className="text-2xl font-bold text-[#7a87ea] cursor-pointer"
            onClick={() => (window.location.href = "/")}
          >
            Arcobow01
          </div>
        </div>
        <div className="w-full max-w-[1116px]">
          <div className="flex flex-col items-center w-full">
            <span className="text-[#e8e8e9] text-6xl font-medium pt-6">
              SEARCH
            </span>
            <div className="flex justify-between items-center w-full mb-8 border-b-2 border-[#9ba2ac]">
              <input
                type="text"
                placeholder="Search destinations,activities and eat"
                className="w-full p-3 font-medium outline-none placeholder:text-[#d9d7d7] placeholder:text-base"
                value={searchValue}
                onChange={handleSearchChange}
              />
              <div className="w-[18px] h-[18px] mr-3 flex-shrink-0">
                <img src="icon/search2.png" alt="search" />
              </div>
            </div>
          </div>
          {isShowSearchResults ? (
            // 顯示搜索結果
            <div className="w-full flex flex-col mb-8">
              <span className="text-[#5c687a] text-xl font-semibold">
                Search Results for:
              </span>
              {searchResults.length > 0 || googleResults.length > 0 ? (
                <>
                  {/*  // 顯示本地搜索結果 */}
                  <ul className="flex flex-wrap gap-5 mt-3 w-full">
                    {searchResults.map((item) => {
                      return (
                        <div key={item.id} className="w-full border-b pb-4">
                          <Link
                            rel="stylesheet"
                            target="_top"
                            to={{
                              pathname: `/detailspage`,
                              search: `?id=${item.id}&${item.category}/${item.urlinform}/`,
                            }}
                            // key={item.id}
                            className="text-[#5b68d3] hover:text-[#5b68d3] font-semibold"
                          >
                            {item.title}
                          </Link>
                          <p className="text-[#5c687a] text-sm mt-1">
                            {item.description}
                          </p>
                          <li className="w-[104px] h-[104px] mt-2 rounded-full overflow-hidden shadow-md border-[1px]">
                            <img
                              src={item.images[0]}
                              alt={item.title}
                              className="w-full h-full object-cover rounded-full"
                            />
                          </li>
                        </div>
                      );
                    })}
                  </ul>
                  {/* 顯示Google搜索結果 {googleResults.length > 0 && ( */}
                  <div className="mt-5">
                    {/* <span className="text-[#5c687a] text-xl font-semibold">
                      Google Search Results:
                    </span> */}
                    <div className="mt-0 space-y-4">
                      {googleResults.map((result, index) => (
                        <div key={index} className="w-full border-b pb-4">
                          <a
                            href={result.link}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-[#5b68d3] hover:text-[#5b68d3] font-semibold"
                          >
                            {result.title}
                          </a>
                          <p className="text-[#5c687a] text-sm mt-1">
                            {result.snippet}
                          </p>
                          {result.pagemap?.cse_thumbnail && (
                            <img
                              src={result.pagemap.cse_thumbnail[0].src}
                              alt={result.title}
                              className="mt-2 rounded-full w-[104px] h-[104px] object-cover shadow-md border-[1px]"
                            />
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                  {/* )} */}
                </>
              ) : (
                // 顯示 "No results found"
                <p className="text-[#9ba2ac] text-base mt-3">
                  No results found...
                </p>
              )}
            </div>
          ) : (
            // 顯示推薦結果
            <div className="flex flex-col">
              <div className="flex flex-col mb-6">
                <p className="text-[#5c687a] text-xl font-semibold">
                  Suggested keywords:
                </p>
                <div className="mt-2 py-1 gap-2 flex flex-wrap">
                  {[
                    "Travel",
                    "Guides",
                    "Food",
                    "Hotels",
                    "China",
                    "Japan",
                    "Indonesia",
                  ].map((item) => (
                    <span
                      key={item}
                      className="py-1.5 px-3 bg-[#eeeeef] rounded-full text-sm font-medium text-[#5c687a] hover:text-[#5b68d3] cursor-pointer"
                      onClick={() => {
                        setSearchValue(item);
                        setIsShowSearchResults(true);
                        handleSearchChange({
                          target: { value: item },
                        } as React.ChangeEvent<HTMLInputElement>);
                      }}
                    >
                      {item}
                    </span>
                  ))}
                </div>
              </div>
              <span className="text-[#5c687a] text-xl font-semibold">
                Popular Recommendations:
              </span>
              <ul className="flex flex-wrap gap-5 mt-3 mb-8">
                {popularRecommendations.map((item) => {
                  return (
                    <div key={item.id} className="w-full border-b pb-4">
                      <Link
                        rel="stylesheet"
                        target="_top"
                        to={{
                          pathname: `/detailspage`,
                          search: `?id=${item.id}&${item.category}/${item.urlinform}/`,
                        }}
                        // key={item.id}
                        className="text-[#5b68d3] hover:text-[#5b68d3] font-semibold"
                      >
                        {item.title}
                      </Link>
                      <p className="text-[#5c687a] text-sm mt-1">
                        {item.description}
                      </p>
                      <li className="w-[104px] h-[104px] mt-2 rounded-full overflow-hidden shadow-md border-[1px]">
                        <img
                          src={item.images[0]}
                          alt={item.title}
                          className="w-full h-full object-cover rounded-full"
                        />
                      </li>
                    </div>
                  );
                })}
              </ul>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default SearchBar;
